import type { QueryKey } from "@tanstack/react-query";

/** Query-key factory for the compensation-plan settings surface. Reads register
 *  under `compensationPlanKeys.all` so a save invalidates every effective /
 *  version / scope read with ONE prefix invalidation. */
export const compensationPlanKeys = {
  all: ["leadgen-comp-plan"] as const,
  effective: (leadGeneratorId: string, asOf?: string): QueryKey => [
    ...compensationPlanKeys.all,
    "effective",
    leadGeneratorId,
    asOf ?? null,
  ],
  programDefault: (): QueryKey => [...compensationPlanKeys.all, "program-default"],
  forGenerator: (leadGeneratorId: string): QueryKey => [
    ...compensationPlanKeys.all,
    "generator",
    leadGeneratorId,
  ],
  versions: (leadGeneratorId?: string): QueryKey => [
    ...compensationPlanKeys.all,
    "versions",
    leadGeneratorId ?? null,
  ],
};
